import { getCookie, setCookie } from '@shared/util/cookie';
import { DEV } from 'esm-env';

let isEnabled = null as boolean | null;

const URL = 'https://tolgee.skilllab.dev';
const COOKIE_NAME = 'tolgee_ICE';

export const isInContextEditorEnabled = () => {
  try {
    return isEnabled || (isEnabled = !!getCookie(COOKIE_NAME));
  } catch (ex) {
    console.warn('Tolgee is disabled because of error', ex);
    return (isEnabled = false);
  }
};

export const enableInContextEditor = (token: string) => {
  try {
    setCookie(COOKIE_NAME, { url: URL, token });
    window.location.reload();
  } catch (ex) {
    console.warn('Tolgee cannot be enabled because of error', ex);
  }
};

if (DEV) {
  (window as any).enableInContextEditor = enableInContextEditor;
}

export const disableInContextEditor = () => {
  try {
    setCookie(COOKIE_NAME, {}, -1000);
    window.location.reload();
  } catch (ex) {
    console.warn('Tolgee cannot be disabled because of error', ex);
  }
};

export const getConfig = () => {
  try {
    const config = getCookie(COOKIE_NAME) as { url: string; token: string };
    return config;
  } catch (ex) {
    console.warn('Cannot load Tolgee config because of error', ex);
  }
};

export const getToggleButtonLabel = (enabled: boolean) =>
  enabled ? 'Disable In-Context Editor' : 'Enable In-Context Editor';
